import React from 'react';
import { ArrowLeft } from 'lucide-react';

const UploadHeader = ({ onBack }) => {
  return (
    <div className="space-y-4">
      <button
        onClick={onBack}
        className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
        type="button"
      >
        <ArrowLeft className="w-5 h-5" />
        <span>Back</span>
      </button>
      <h1 className="text-2xl font-semibold text-gray-900">
        Upload any collateral for your deal
      </h1>
    </div>
  );
};

export default UploadHeader;